import { Entry } from '../Entry'

export function Entry20240117() {
  return (
    <Entry title="Jan 17 2024 - v3.5.11">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/15665/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
